import { useEffect, useState} from "react";

const BookingScreen = () => {
    const [platform, setPlatform] = useState("unknown");

    useEffect(() => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
      if (/android/i.test(userAgent)) {
        setPlatform("android");
        window.location.href = "https://play.google.com/store/apps/details?id=com.spotsaver.www";
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        setPlatform("ios");
        window.location.href = "https://apps.apple.com/app/6741795199"; 
      } else {
        setPlatform("desktop");
      }
    }, []);
  
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>Redirecting to the app store...</h2>
        {platform === "desktop" && (
          <>
            <p>You seem to be on a desktop. You can install the app using one of the options below:</p>
            <div style={{ marginTop: "1rem", display: "flex", justifyContent: "center", gap: "1rem" }}>
              <a
                href="https://play.google.com/store/apps/details?id=com.spotsaver.www"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  style={{ height: "60px" }}
                />
              </a>
              <a
                href="https://apps.apple.com/app/6741795199"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Download on the App Store"
                  style={{ height: "60px" }}
                />
              </a>
            </div>
          </>
        )}
      </div>
    );
  };

export default BookingScreen;
